import { render, staticRenderFns } from "./SpacesAvailable.vue?vue&type=template&id=45d01e3c&"
import script from "./SpacesAvailable.vue?vue&type=script&lang=js&"
export * from "./SpacesAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports